import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';
import Layout from "./layouts/layout";
import Home from "./pages/Home";
import Auth from "./pages/Auth";
import Logout from "./pages/Logout";
import List from "./pages/Users/List";
import ClientsList from "./pages/Clients/List";
import ClientsAdd from "./pages/Clients/Add";
import MerchantsList from "./pages/Merchants/List";
import MerchantsAdd from "./pages/Merchants/Add";
import PartnersList from "./pages/Partners/List";
import AddUser from "./pages/Users/Add";
import ProcessingList from './pages/ProcessingList'
import ProcessingGroups from './pages/ProcessingGroups'
import ProcGroups2 from './pages/ProcGroups2'
import * as RuntimeProvidersModule from './pages/RuntimeProviders'
import AddGoods from "./pages/Goods/Add";
import PatnersAdd from "./pages/Partners/Add";
import TGUsersList from "./pages/TGUsers/List";
import CryptoList from "./pages/Crypto/List";
import { AuthProvider } from "./context/AuthContext";
import PlumLoader from "./layouts/components/PlumLoader";
import ListGoods from "./pages/Goods/List";
import ListOrders from "./pages/Orders/List";
import ListFunPay from "./pages/FunPayOrder/List";
import ChatPage from './pages/FunPayOrder/ChatPage';
import AccountingList from './pages/Accounting/List';
import WithdrawalsList from './pages/Withdrawals/List';
import BugTRList from './pages/BugTR/List';
import GiftCardsList from './pages/GiftCards/List';
import TGAccountsAdd from './pages/TGAccounts/Add';
import TGAccountsList from './pages/TGAccounts/List';
import TGAccountsChats from './pages/TGAccounts/Chats';
import TGAccountsSendMessage from './pages/TGAccounts/SendMessage';
import TGAccountsChatView from './pages/TGAccounts/ChatView';
import Broadcasts from './pages/Broadcasts';
import TicketsList from './pages/Tickets/List';
import TicketDetail from './pages/Tickets/Detail';
import BlacklistList from './pages/Blacklist/List';
import ProfitReport from './pages/ProfitReport';
import GamesList from './pages/Games/List';
import GamesHistory from './pages/Games/History';
import V4Layout from './pages/V4/V4Layout';
import V4Overview from './pages/V4/Overview';
import V4Orders from './pages/V4/Orders';
import V4OrderDetail from './pages/V4/OrderDetail';
import V4Configuration from './pages/V4/Configuration';
import V4Queues from './pages/V4/Queues';
import V4Secrets from './pages/V4/Secrets';
import V4System from './pages/V4/System';
import V4TelegramUsers from './pages/V4/TelegramUsers';
import V4SiteBalances from './pages/V4/SiteBalances';
import V4Payouts from './pages/V4/Payouts';
import V4ProcessingDebts from './pages/V4/ProcessingDebts';
import V4CryptoAddresses from './pages/V4/CryptoAddresses';
import V4TelegramBot from './pages/V4/TelegramBot';
import V4RoutingPreview from './pages/V4/RoutingPreview';

const RuntimeProviders = RuntimeProvidersModule.default || RuntimeProvidersModule.RuntimeProviders;
export default function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const checkPageLoad = () => {
        // Если страница полностью загруженаa
        if (document.readyState === 'complete') {
            setLoading(false);
        } else {
            // Если страница не загружена, продолжаем проверку
            setTimeout(checkPageLoad, 100);
        }
    };

    checkPageLoad(); // Запускаем проверку

    return () => {
        // Очистка в случае размонтирования компонента
    };
}, []);

  // Когда состояние loading = true, показываем лоадер
  if (loading) {
    return <PlumLoader />;
  }
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/auth" element={<Auth />} /> 
            <Route path="/logout" element={<Logout />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/users/list" element={<List />} />
              <Route path="/tgusers" element={<TGUsersList />} />
              <Route path="/crypto/wallets" element={<CryptoList />} />
              <Route path="/processing/list" element={<ProcessingList />} />
              <Route path="/processing/groups" element={<ProcessingGroups />} />
              <Route path="/processing/procgroups2" element={<ProcGroups2 />} />
              <Route path="/processing/runtime-providers" element={<RuntimeProviders />} />
              <Route path="/clients/list" element={<ClientsList />} />
              <Route path="/clients/add" element={<ClientsAdd />} />
              <Route path="/merchants/list" element={<MerchantsList />} />
              <Route path="/merchants/add" element={<MerchantsAdd />} />
              <Route path="/users/add" element={<AddUser />} />
              <Route path="/goods/add" element={<AddGoods />} />
              <Route path="/goods/edit/:id" element={<AddGoods />} />
              <Route path="/goods/list" element={<ListGoods />} />
              <Route path="/partners/add" element={<PatnersAdd />} />
              <Route path="/partners/edit/:id" element={<PatnersAdd />} />
              <Route path="/partners/list" element={<PartnersList />} />
              <Route path="/orders/list" element={<ListOrders />} />
              <Route path="/orders/funpay" element={<ListFunPay />} />
              <Route path="/funpay-chat/:id" element={<ChatPage />} />
              <Route path="/accounting/list" element={<AccountingList />} />
              <Route path="/withdrawals/list" element={<WithdrawalsList />} />
              <Route path="/bugtr" element={<BugTRList />} />
              <Route path="/giftcards" element={<GiftCardsList />} />
              <Route path="/tg-accounts/add" element={<TGAccountsAdd />} />
              <Route path="/tg-accounts/list" element={<TGAccountsList />} />
              <Route path="/tg-accounts/edit/:id" element={<TGAccountsAdd />} />
              <Route path="/tg-accounts/:id/chats" element={<TGAccountsChats />} />
              <Route path="/tg-accounts/:id/chats/:chatId/view" element={<TGAccountsChatView />} />
              <Route path="/tg-accounts/:id/send-message" element={<TGAccountsSendMessage />} />
              <Route path="/broadcasts" element={<Broadcasts />} />
              <Route path="/tickets" element={<TicketsList />} />
              <Route path="/tickets/:id" element={<TicketDetail />} />
              <Route path="/blacklist" element={<BlacklistList />} />
              <Route path="/profit-report" element={<ProfitReport />} />
              <Route path="/games/list" element={<GamesList />} />
              <Route path="/games/history" element={<GamesHistory />} />
              <Route path="/v4" element={<V4Layout />}>
                <Route index element={<V4Overview />} />
                <Route path="orders" element={<V4Orders />} />
                <Route path="orders/:orderId" element={<V4OrderDetail />} />
                <Route path="merchants" element={<V4Configuration kind="merchants" />} />
                <Route path="processings" element={<V4Configuration kind="processings" />} />
                <Route path="routes" element={<><V4Configuration kind="routes" /><V4RoutingPreview /></>} />
                <Route path="tariffs" element={<V4Configuration kind="tariffs" />} />
                <Route path="queues" element={<V4Queues />} />
                <Route path="telegram-users" element={<V4TelegramUsers />} />
                <Route path="site-balances" element={<V4SiteBalances />} />
                <Route path="payouts" element={<V4Payouts />} />
                <Route path="processing-debts" element={<V4ProcessingDebts />} />
                <Route path="crypto-addresses" element={<V4CryptoAddresses />} />
                <Route path="telegram-bot" element={<V4TelegramBot />} />
                <Route path="secrets" element={<V4Secrets />} />
                <Route path="system" element={<V4System />} />
                <Route path="*" element={<Navigate to="/v4" replace />} />
              </Route>
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
